if (window.bundlePublicPath) {
  __webpack_public_path__ = window.bundlePublicPath; // eslint-disable-line no-undef, camelcase
}
